import React from 'react';
import { message } from 'antd';

export const DEFAULT_SELECT_VALUE = 'All';

// Not to change the following values.
// Scope of impact: management table, management bulk action
export const FLOW = 'flow';
export const METRICS = 'metrics';
export const MAPPED_EVENTS = 'mapped_events';
export const CUSTOM_DIMENSION = 'custom_dimension';
export const BLOCK_EVENTS = 'block_events';
export const BLOCK_VIDEO_EVENTS = 'block_video_events';

export const dateFields = ['created_at', 'deployed_at', 'updated_at', 'block_timestamp'];
export const supportSearchFields = [
  ...dateFields,
  'updated_by',
  'created_by',
  'is_draft',
  'status',
  // metric
  'metric_name',
  'related_event',
  // flow
  'flow_name',
  'related_events',
  'associated_dimension_names',
  // dimension
  'display_name',
  'attribute_name',
  'attribute_type',
  'mapped_event_names',
  'associated_flow_names',
  'associated_metric_names',
  // mapped event
  'event_category',
  'event_name',
  'related_metrics',
  // block event
  'block_rules',
  'block_by',
];

// bulk action types
export const DEPLOYED = 'deployed';
export const UNDEPLOYED = 'undeployed';
export const DELETED = 'deleted';

export const Id_Key_MAPPING: Record<string, string> = {
  [FLOW]: 'flow_id',
  [METRICS]: 'metric_id',
  [MAPPED_EVENTS]: 'event_id',
  [CUSTOM_DIMENSION]: 'custom_dimension_id',
};

export const handleAction = ({
  action,
  params,
  onSuccess,
  successMessage,
  errorMessage: errorMessageProps,
  showSensorDelayMessage = false,
}: {
  action: (params: any, options: any) => void;
  params: any;
  onSuccess?: () => void;
  successMessage?: string;
  errorMessage?: string;
  showSensorDelayMessage?: boolean;
}) => {
  action(params, {
    onSuccess: () => {
      onSuccess?.();
      if (showSensorDelayMessage) {
        message.success({
          content: React.createElement(
            'div',
            { style: { textAlign: 'left' } },
            successMessage,
            React.createElement('br'),
            'Sensors may take up to 5 minutes to reflect changes.'
          ),
          duration: 5,
        });
      } else {
        message.success(successMessage);
      }
    },
    onError: (error: any) => {
      const errorMessage =
        errorMessageProps ||
        error?.response?.data?.msg ||
        error?.response?.data?.message ||
        'An error occurred';
      message.error(errorMessage);
    },
  });
};
